export const landingCarousel = [{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_D_HB_192_CasualShirts_EOSS?resMode=sharp2&wid=1366&hei=544"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_D_HB_193_FormalShirts_EOSS?resMode=sharp2&wid=1366&hei=544"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_D_HB_195_Suits_EOSS?resMode=sharp2&wid=1366&hei=544"
}]

export const landingCarousel2 = [{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_eoss_sbc_D_01?resMode=sharp2&wid=244&hei=189",
    tag:"Shirts",
    category:"shirts"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_eoss_sbc_D_02?resMode=sharp2&wid=244&hei=189",
    tag:"Trousers",
    category:"trousers"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_eoss_sbc_D_05?resMode=sharp2&wid=244&hei=189",
    tag:"Denims",
    category:"denims"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_eoss_sbc_D_03?resMode=sharp2&wid=244&hei=189",
    tag:"T-Shirts",
    category:"t-shirts"
},
{
    src:"https://assets.trendin.com/img/app/categorymedia/production/4/422-131-13447.png?auto=format&w=270",
    tag:"Ties",
    category:"ties"
}]

export const shopTheLooks=[{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_gamescape_look8"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_gamescape_look9"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_gamescape_look6"
},
{
    src:"https://s7ap1.scene7.com/is/image/adityabirlafashion/LP_gamescape_look7"
}]

export const Trending = [
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39629398-13437136.jpg?auto=format&w=390",
        name:"Men Green Slim Fit Full-sleeves Shirt",
        category:"CASUAL SHIRTS",
        rate:"2599"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/949713-13794131.jpg?auto=format&w=390",
        name:"God and King Full-sleeves Shirt",
        category:"FORMAL SHIRTS",
        rate:"3999"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/927847-11738888.jpg?auto=format&w=390",
        name:"Permapress Wrinkle Free Trousers",
        category:"FORMAL TROUSERS",
        rate:"3299"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619564-12663167.jpg?auto=format&w=390",
        name:"Men Blue Embroidered Tie",
        category:"TIES",
        rate:"1799"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/8/896854-10950486.jpg?auto=format&w=390",
        name:"Brown Textured Leather Wallet",
        category:"WALLETS",
        rate:"1479"
    }
]

export const TShirts = [
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39643732-13437087.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653698-13435161.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/951682-12280925.jpg?auto=format&w=390",
        name:"Blue Print Crew Neck",
        category:"CREW NECK T-SHIRTS",
        rate:"766",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653700-13435209.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/8/894839-10894365.jpg?auto=format&w=390",
        name:"Blue Print Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39643749-13437024.jpg?auto=format&w=390",
        name:"Blue Print Oversized T-Shirt",
        category:"CREW NECK T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39642414-13339797.jpg?auto=format&w=390",
        name:"Blue Print Polo Neck T-Shirt",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39672359-13624515.jpg?auto=format&w=390",
        name:"Blue Print Polo Neck T-Shirt",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39643732-13437087.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653698-13435161.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/951682-12280925.jpg?auto=format&w=390",
        name:"Blue Print Crew Neck",
        category:"CREW NECK T-SHIRTS",
        rate:"766",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653700-13435209.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179",
        desc:"Show the world your sophisticated style with this black Louis Philippe Jeans slim-fit shirt. This solid pattern full-sleeve cotton shirt for men is perfect for casual occasions when you want to look your best. The light and breathable fabric ensures it is comfortable to wear all day long. Complete with its unique and chic stylish, the perfect addition for any fashion-forward male. Dress to impress!"
    }
]

export const Trousers=[{
    src:"https://imagescdn.louisphilippe.com/img/app/product/8/809026-9619144.jpg?auto=format&w=390",
    name:"Permapress Wrinkle Free Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"3299",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/3/39670970-13589477.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"1879",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/912273-11293325.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit  Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"2799",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/7/792212-9283110.jpg?auto=format&w=390",
    name:"Men Blue Slim Fit  Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"1599",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},
{
    src:"https://imagescdn.louisphilippe.com/img/app/product/7/703947-7620995.jpg?auto=format&w=390",
    name:"Men Blue Slim Fit Check",
    category:"FORMAL TROUSERS",
    rate:"1651",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},
{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/922651-11603687.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit Check",
    category:"FORMAL TROUSERS",
    rate:"1951",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},
{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/930760-11799931.jpg?auto=format&w=390",
    name:"Men Blue Slim Fit Solid",
    category:"FORMAL TROUSERS",
    rate:"1591",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/3/39670970-13589477.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"1879",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/912273-11293325.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit  Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"2799"
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/7/792212-9283110.jpg?auto=format&w=390",
    name:"Men Blue Slim Fit  Black Trouser",
    category:"FORMAL TROUSERS",
    rate:"1599",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},
{
    src:"https://imagescdn.louisphilippe.com/img/app/product/7/703947-7620995.jpg?auto=format&w=390",
    name:"Men Blue Slim Fit Check",
    category:"FORMAL TROUSERS",
    rate:"1651",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
},
{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/922651-11603687.jpg?auto=format&w=390",
    name:"Men Blue Regular Fit Check",
    category:"FORMAL TROUSERS",
    rate:"1951",
    desc:"A pair of well-tailored trousers is a great style investment to a gentlemans wardrobe. These Blue Solid Regular Fit trousers from Louis Philippe by Louis Philippe are both smart and comfortable."
}]

export const Ties = [{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/928276-11745408.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/8/875004-10454308.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/922541-11600058.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619589-12663641.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/928276-11745408.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/8/875004-10454308.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/922541-11600058.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619589-12663641.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/928276-11745408.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/8/875004-10454308.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/9/922541-11600058.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},{
    src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619589-12663641.jpg?auto=format&w=390",
    name:"Men Blue Embroided",
    category:"TIES",
    rate:"1799",
    desc:"For the quint essential blue-tie lover, Louis Philippe brings you this solid blue tie that`s bound to make a powerful statement. Ideal for formal occasions, it`s made from 100% polyester, ensuring comfort and durability without harming the environment. Its exquisite craftsmanship adds a refined touch to your ensemble, making you look sharp and sophisticated. Boost your confidence, charm guests, and make a lasting impression at meetings with this go-to accessory that`ll transcend your wardrobe season after season."
},
]

export const Products=[
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619589-12663641.jpg?auto=format&w=390",
        name:"Men Blue Embroided",
        category:"TIES",
        rate:"1799"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39670970-13589477.jpg?auto=format&w=390",
        name:"Men Blue Regular Fit Black Trouser",
        category:"FORMAL TROUSERS",
        rate:"1879"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/912273-11293325.jpg?auto=format&w=390",
        name:"Men Blue Regular Fit  Black Trouser",
        category:"FORMAL TROUSERS",
        rate:"2799"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/7/792212-9283110.jpg?auto=format&w=390",
        name:"Men Blue Slim Fit  Black Trouser",
        category:"FORMAL TROUSERS",
        rate:"1599"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39643732-13437087.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653698-13435161.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179"
    },
    {
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/951682-12280925.jpg?auto=format&w=390",
        name:"Blue Print Crew Neck",
        category:"CREW NECK T-SHIRTS",
        rate:"766"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39653700-13435209.jpg?auto=format&w=390",
        name:"Blue Solid Polo Neck",
        category:"POLO T-SHIRTS",
        rate:"1179"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/8/875004-10454308.jpg?auto=format&w=390",
        name:"Men Blue Embroided",
        category:"TIES",
        rate:"1799"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/9/922541-11600058.jpg?auto=format&w=390",
        name:"Men Blue Embroided",
        category:"TIES",
        rate:"1799"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/3/39619589-12663641.jpg?auto=format&w=390",
        name:"Men Blue Embroided",
        category:"TIES",
        rate:"1799"
    },{
        src:"https://imagescdn.louisphilippe.com/img/app/product/7/792212-9283110.jpg?auto=format&w=390",
        name:"Men Blue Slim Fit  Black Trouser",
        category:"FORMAL TROUSERS",
        rate:"1599"
    },

]